module.exports = __webpack_public_path__ + "static/media/5.426eb283.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/5.png
// module id = 1244
// module chunks = 0